import type { FC, ReactNode } from "react";
import type { Theme } from "@mui/material";

import { Box, Stack, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";

import { makeStyles } from "@mui/styles";

import { useTheme } from "@mui/material";

interface TabData {
  value: string;
  label: string;
  content: ReactNode;
  visible?: boolean;
}

interface TabsComponentProps {
  selectedTab: string;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  tabs: TabData[];
  endContent?: ReactNode;
}

const Tabs: FC<TabsComponentProps> = ({
  selectedTab,
  onTabChange,
  tabs,
  endContent,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <TabContext value={selectedTab}>
      <Stack
        sx={{
          width: 1,
          position: "relative",
          justifyContent: "space-between",
        }}
        direction='row'
      >
        <TabList
          onChange={onTabChange}
          TabIndicatorProps={{
            style: {
              background: theme.palette.main.primary.o,
              height: 3,
              zIndex: 10,
            },
          }}
        >
          {tabs.map(
            tab =>
              (typeof tab?.visible === "undefined" || tab.visible) && (
                <Tab
                  key={tab.value}
                  disableRipple
                  label={tab.label}
                  value={tab.value}
                  className={classes.tab}
                  style={{
                    color:
                      selectedTab === tab.value
                        ? theme.palette.natural.t1
                        : theme.palette.natural.t2,
                  }}
                />
              ),
          )}
        </TabList>
        {endContent}
        <Box className={classes.tabsDivider} />
      </Stack>
      {tabs.map(tab => (
        <TabPanel key={tab.value} value={tab.value} style={{ padding: 0 }}>
          {tab.content}
        </TabPanel>
      ))}
    </TabContext>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  tabsDivider: {
    width: "100%",
    height: 3,
    backgroundColor: theme.palette.natural.t3,
    position: "absolute",
    bottom: 0,
  },
  tab: {
    textTransform: "none",
    fontSize: 16,
  },
}));

export default Tabs;
